module.exports = __webpack_public_path__ + "img/summary_battery_export.3fea83e5.svg";